import React, { useState } from 'react';
import { getSmoothStepPath, EdgeLabelRenderer, BaseEdge } from 'reactflow';
import { FaTimes } from 'react-icons/fa';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  selected,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8,
  });

  const onEdgeClick = (evt, id) => {
    evt.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  const edgeStyle = {
    stroke: selected ? '#5e35b1' : (isHovered ? '#5e35b1' : '#9ca3af'),
    strokeWidth: selected ? 3 : (isHovered ? 2.5 : 2),
    transition: 'all 0.2s ease',
    strokeDasharray: selected ? 'none' : 'none',
    ...style,
  };

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={edgeStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
      
      {/* Delete Button */}
      {(isHovered || selected) && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <button
              className="edge-delete-btn"
              onClick={(event) => onEdgeClick(event, id)}
              title="Delete Connection"
            >
              <FaTimes />
            </button>
          </div>
        </EdgeLabelRenderer>
      )}
      
      {/* Connection Label */}
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -100%) translate(${labelX}px,${labelY}px)`,
              fontSize: 11,
              fontWeight: 500,
              background: 'white',
              padding: '4px 8px',
              borderRadius: '12px',
              border: '1px solid #e1e5e9',
              color: '#6b7280',
              pointerEvents: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
            className="nodrag nopan"
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default CustomEdge;